export default "__VITE_ASSET__792367b6__"